import { render, staticRenderFns } from "./KusClientListSearch.vue?vue&type=template&id=8fff5d1e"
import script from "./KusClientListSearch.vue?vue&type=script&lang=js"
export * from "./KusClientListSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports